import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=18169e66&scoped=true"
import script from "./SurveyList.vue?vue&type=script&lang=ts"
export * from "./SurveyList.vue?vue&type=script&lang=ts"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=18169e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18169e66",
  null
  
)

export default component.exports